// Ouvrir / fermer <dialog>
document.addEventListener('click', (e) => {
    const btnOpen = e.target.closest('[data-dialog]');   // ex: data-dialog="#d1"
    const btnClose = e.target.closest('[data-dialog-close]');
    if (btnOpen) {
        const sel = btnOpen.getAttribute('data-dialog');
        const dlg = document.querySelector(sel);
        if (dlg?.showModal) dlg.showModal();
        else if (dlg) dlg.setAttribute('open', '');
    }
    if (btnClose) btnClose.closest('dialog')?.close();
});
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') document.querySelectorAll('dialog[open]').forEach(d => d.close());
});
